import Vue from 'vue'
import Vuex from 'vuex'
import motiflow from "../api/motiflow"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    'hasError': null,
    'loading': true,
    'boards': [],
    'patterns': [],
    'error': false,
    'boardId': 'all',
    'selected': {id:null},
    'colors':null,
    'colorId':null,
    'activePattern':{},
    'previewOpen':false,
    'previewPattern':{},
    'token':null,
    'baseURL':null,
    'externalProcessBusy':false,
  }
  ,
  getters:{
    getToken:state => {
      return state.token;
    },
    configToken: state => {
      return state.token;
    },
    configBoard: state=>{
      return state.boardId;
    },
    configColor: state => {
      return state.color
    },
    getBoards: state => {
      return state.boards;
    },
    getPatterns: state => {
      return state.patterns;
    },
    getSelected:state =>{
      return state.selected;
    },
    getPreview: state =>{
      return state.previewPattern;
    },
    showPreview : state=>{
      return state.previewOpen;
    },
    filterColor: state =>{
      return state.colorId;
    }
  },
  mutations: {
    SET_LOADING_STATE(state,status){
      state.loading = status
    },
    SET_BOARDS(state,boards){
      state.boards = boards;
    },
    SET_PATTERNS(state,patterns){
      state.patterns = patterns;
    },
    SET_ERROR(state,error){
      state.error = error;
    },
    SET_BOARD_ID(state,id){
      state.boardId = id;
    },
    SET_PREVIEW(state,data){
      state.previewOpen = true;
      state.previewPattern = data;
    },
    UNSET_PREVIEW(state){
      state.previewOpen = false;
      state.previewPattern = {};
    },
    UNSET_SELECTED(state){
      state.previewPattern = {};
      state.selected =   {id:null};
    },
    SET_SELECTED(state,data){
      state.selected = data;
    },
    SET_TOKEN(state,token){
      state.token = token;
    },
    SET_BASE_URL(state,baseURL){
      if(baseURL === '') {
        baseURL = null
      }
      state.baseURL = baseURL;
    },
    SET_COLOR_ID(state,colorId){
      state.colorId = colorId;
    },
    SET_EXTERNAL_PROCESS(state,value){
      state.externalProcessBusy = value;
    }
  },
  actions: {
    setToken(context,token){
      context.commit('SET_TOKEN',token);
    },

    setBaseURL(context, baseURL) {
      context.commit('SET_BASE_URL',baseURL);
    },

    setExternalProcess(context,state){ context.commit('SET_EXTERNAL_PROCESS',state)},

    setBoardId(context,id){
      context.commit('SET_BOARD_ID',parseInt(id));
    },

    setColorId(context,id){
      context.commit('SET_COLOR_ID',parseInt(id));
      context.dispatch('fetchPatterns');
    },

    setSelected(context,data){
      context.commit('SET_SELECTED',data);
    },
    setPreview(context,data){
      context.commit('SET_PREVIEW',data)
    },
    hidePreview(context){
      context.commit('UNSET_PREVIEW')
    },
    unsetSelected(context){
      context.commit('UNSET_SELECTED');
    },
    setStartPattern(context,id){
      context.commit('SET_LOADING_STATE',true);

      motiflow.getSinglePattern(id).then((result) =>{
        if(result.data.length) {
          context.commit('SET_SELECTED',result.data[0]);
        }
        }).catch(()=>{

        }).finally(()=> {
          context.commit('SET_LOADING_STATE', false);
        });
    },

    fetchPatterns(context){
       context.commit('SET_LOADING_STATE',true);
       motiflow.getPatterns().then((result)=>{

         if(result.data.length){
           context.commit('SET_PATTERNS',result.data);
         }else{
           context.commit('SET_PATTERNS',[]);
           context.commit('SET_ERROR',true);
         }
       }).catch(()=>{

       }).finally(()=> {
             context.commit('SET_LOADING_STATE', false);
       });
    },

    fetchBoards(context){
      motiflow.getBoards().then((result)=>{
        context.commit('SET_BOARDS',result.data);
      }).catch(()=>{

      }).finally(()=> {
        context.commit('SET_LOADING_STATE', false);
      });
    }

  }
});